/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCustomerNumberItemRequestBuilder, WithCustomerNumberItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/customer
 */
export interface CustomerRequestBuilder extends BaseRequestBuilder<CustomerRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.carts.customer.item collection
     * @param customerNumber Unique identifier of the item
     * @returns {WithCustomerNumberItemRequestBuilder}
     */
     byCustomerNumber(customerNumber: string) : WithCustomerNumberItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CustomerRequestBuilderUriTemplate = "{+baseurl}/api/carts/customer";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CustomerRequestBuilderNavigationMetadata: Record<Exclude<keyof CustomerRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCustomerNumber: {
        requestsMetadata: WithCustomerNumberItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["customerNumber"],
    },
};
/* tslint:enable */
/* eslint-enable */
